import { useEffect } from "react";
import { useLocation, useNavigationType } from "react-router-dom";
import { smoothScrollToTop } from "../utils/scrollUtils";

/**
 * Institutional Scroll Reset Component
 * Resets the vertical viewport to the origin upon registry navigation.
 */
const ScrollToTop = () => {
    const { pathname, state } = useLocation();
    const navType = useNavigationType();

    useEffect(() => {
        // Do not scroll to top if we are navigating back (POP) or opening a modal (state.background)
        if (navType !== "POP" && !state?.background) {
            // Native smooth scroll matches typical page transition timing (~250ms)
            requestAnimationFrame(() => {
                window.scrollTo({
                    top: 0,
                    behavior: 'smooth'
                });
            });
        }
    }, [pathname, navType, state]);

    return null;
};


export default ScrollToTop;

